import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(''),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/TemplateOne/HomeView.vue')
    },
    {
      path: '/race/:id',
      name: 'race',
      component: () => import('../views/TemplateOne/RaceView.vue')
    },
  ]
})

export default router
